// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__23nkV","messages":"Chat_messages__Pw8_u","dateDivider":"Chat_dateDivider__2Xszc"};